import { render, staticRenderFns } from "./productChild.vue?vue&type=template&id=0d4b8d47&scoped=true&"
import script from "./productChild.vue?vue&type=script&lang=js&"
export * from "./productChild.vue?vue&type=script&lang=js&"
import style0 from "./productChild.vue?vue&type=style&index=0&id=0d4b8d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b8d47",
  null
  
)

export default component.exports